import { type MCPServerInfo } from '../../types';
import { extractBareHost } from '../../../strings';

const MCP_PATH = '/api/v4/mcp';

const GitlabRemoteServer: MCPServerInfo = {
  serverId: 'GITLAB_REMOTE',
  name: 'GitLab',
  slug: 'gitlab-remote',
  description: 'GitLab MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    transport: 'STREAMABLE_HTTP',
    // Per-instance host: gitlab.com for SaaS, or the customer's own
    // host for Self-Managed.
    mcpServerUrl: (config: Map<string, string>): string => {
      const host = extractBareHost(config.get('host'), {
        label: 'GitLab host',
        example: 'gitlab.com'
      });
      return `https://${host}${MCP_PATH}`;
    }
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {
      host: {
        type: 'string',
        description:
          'GitLab host — enter gitlab.com for GitLab.com, or your GitLab Self-Managed host (e.g. gitlab.example.com)',
        sensitive: false,
        default: 'gitlab.com',
        isUrlParameter: true
      }
    }
  },
  installConfig: { required: [], properties: {} }
};

export default GitlabRemoteServer;
